"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

interface MeteorsProps {
  number?: number;
  className?: string;
}

interface MeteorData {
  top: number;
  left: number;
  delay: number;
  duration: number;
  width: number;
  tailWidth: number;
}

function generateMeteors(count: number): MeteorData[] {
  return Array.from({ length: count }, () => ({
    top: Math.random() * 50 - 10,
    left: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 6 + 2,
    width: Math.random() + 1,
    tailWidth: Math.random() * 80 + 40,
  }));
}

export function Meteors({ number = 20, className }: MeteorsProps) {
  const [meteorsData] = useState<MeteorData[]>(() => generateMeteors(number));

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden",
        className
      )}
    >
      {meteorsData.map((m, i) => (
        <span
          key={i}
          className="pointer-events-none absolute rotate-[215deg] rounded-full bg-primary-foreground"
          style={{
            top: `${m.top}%`,
            left: `${m.left}%`,
            width: `${m.width}px`,
            height: `${m.width}px`,
            animation: `meteor ${m.duration}s linear ${m.delay}s infinite`,
            boxShadow: `0 0 0 1px rgba(255,255,255,0.05), 0 0 2px 1px rgba(255,255,255,0.1), 0 0 ${m.width * 30}px ${m.width * 2}px rgba(255,255,255,0.05)`,
          }}
        >
          {/* Tail */}
          <span
            className="pointer-events-none absolute top-1/2 -z-10 -translate-y-1/2"
            style={{
              width: `${m.tailWidth}px`,
              height: "1px",
              background:
                "linear-gradient(to right, oklch(0.55 0.15 245 / 60%), transparent)",
            }}
          />
        </span>
      ))}
    </div>
  );
}
